<mc-dialog (closeEvent)="close()">
  <div class="forbidden-dialog">
    <mat-icon class="icon" svgIcon="lock-forbidden"></mat-icon>
    <h3 class="title">Restricted Access</h3>
    <span class="description"
      >You don’t have permissions to complete this action, please contact your UserWay account administrator.</span
    >
    <mc-button variant="flat" color="primary" (clickEvent)="close()">Got it</mc-button>
  </div>
</mc-dialog>
